import React from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Splash from '../components/Splash';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const styles = theme => ({
  divider: {
    margin: `${theme.spacing(2)}px 0`
  },
  reportIcon: {
    color: 'red',
    marginLeft: '11px',
    marginBottom: '-5px',
    fontSize: '30px'
  }
});

function getErrorMessage(error = {}) {
  if (error.response) {
    return _.get(error, 'response.data.message');
  }
  if (error.message) {
    return error.message;
  }
  return 'Unknown error';
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    const { history } = this.props;
    this.historyUnlisten = history.listen(() => {
      this.setState({ hasError: false, error: null });
    });
  }

  componentWillUnmount() {
    if (this.historyUnlisten) {
      this.historyUnlisten();
    }
  }

  renderError() {
    const { classes, location, history } = this.props;
    const { error } = this.state;
    return (
      <Splash
        content={
          <>
            <Divider className={classes.divider} />
            <Typography gutterBottom variant="h6">
              <FormattedMessage id="errorView.title" />
              <ReportProblemOutlinedIcon className={classes.reportIcon} />
            </Typography>
            <Typography component="p" />
            <Typography gutterBottom variant="body1">
              {getErrorMessage(error)}
            </Typography>
            <Divider className={classes.divider} />
            {/* <Typography variant="subtitle2">
              <FormattedMessage id="errorView.stack" />
            </Typography>
            <Typography gutterBottom component="div">
              <pre>{error.stack}</pre>
            </Typography> */}
            <Typography variant="subtitle2">
              <FormattedMessage id="errorView.location" />
            </Typography>
            <Typography gutterBottom>
              <code>{location.pathname}</code>
            </Typography>
          </>
        }
        actions={
          <div>
            <Button
              onClick={() => {
                history.push('/');
              }}
              type="submit"
              size="small"
              color="secondary"
              style={{ marginRight: '305px' }}
            >
              <FormattedMessage id="notFoundView.buttonGoToRoot" />
            </Button>
            <Button
              onClick={() => {
                window.open(
                  'https://now.ingka.com/esc?id=sc_cat_item&table=sc_cat_item&sys_id=f972dcf41bea1d50d9b1f7c4464bcb54&recordUrl=com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1&sysparm_id=f972dcf41bea1d50d9b1f7c4464bcb54',
                  '_blank'
                );
              }}
              type="submit"
              size="small"
              color="secondary"
            >
              <FormattedMessage id="notFoundView.incidentButton" />
            </Button>
          </div>
        }
      />
    );
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return this.renderError();
    }

    return children;
  }
}

export default withRouter(withStyles(styles)(ErrorBoundary));
